module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-243.bbfd08fb.jpg";